import React from 'react';
import { Loader2, TrendingUp } from 'lucide-react';

export const SplashScreen: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background text-foreground">
      <div className="flex items-center gap-2 mb-4">
        <div className="h-8 w-8 rounded-lg bg-gradient-to-br from-primary to-blue-600 flex items-center justify-center shadow-md shadow-primary/20">
          <TrendingUp className="h-4 w-4 text-white" />
        </div>
        <span className="text-base font-bold tracking-tight">
          <span>Stock</span>
          <span className="text-primary">Screener</span>
        </span>
      </div>
      <Loader2 className="h-5 w-5 animate-spin text-muted-foreground" />
    </div>
  );
};

export default SplashScreen;
